<script lang="ts">
  interface Props {
    label?: string;
    name?: string;
    value?: string;
    error?: string;
    placeholder?: string;
    disabled?: boolean;
    tabIndex?: number;
    required?: boolean;
    rows?: number;
    isFullHeight?: boolean;
    oninput?: (e: Event) => void;
    onblur?: (e: FocusEvent) => void;
    onfocus?: (e: FocusEvent) => void;
    onchange?: (e: Event) => void;
  }

  let {
    label = '',
    name = '',
    value = '',
    error = '',
    placeholder = '',
    disabled = false,
    tabIndex = 1,
    required = true,
    rows = 3,
    isFullHeight = false,
    oninput,
    onblur,
    onfocus,
    onchange
  }: Props = $props();
</script>

<div class="comp-input" class:is-full-height={isFullHeight} class:error>
  {#if label}
    <label class="label" for={name}
      >{label}
      {#if required}
        <span class="required">*</span>
      {/if}
    </label>
  {/if}
  <div class="input-wrap">
    <textarea
      {name}
      {value}
      {placeholder}
      {disabled}
      {tabIndex}
      {required}
      {rows}
      data-cy={name}
      {oninput}
      {onblur}
      {onfocus}
      {onchange}
></textarea>
  </div>
  {#if error}
    <div class="error">{error}</div>
  {/if}
</div>

<style>
  .comp-input {
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .comp-input .label {
    display: inline-block;
    font-weight: 600;
    font-size: 12px;
    margin-bottom: 8px;
  }
  .comp-input .label .required {
    position: relative;
    font-size: 14px;
    margin-left: 3px;
    color: var(--black);
  }

  .comp-input .input-wrap {
    display: flex;
    position: relative;
  }

  .comp-input textarea {
    width: 100%;
    height: 100px;
    line-height: 1;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.02);
    border-radius: 3px;
    padding: 8px;
    resize: none;
    color: var(--grey-dark);
    font-family: inherit;
  }
  .comp-input textarea:focus {
    outline-color: var(--blue);
  }
  .comp-input textarea:disabled {
    background-color: var(--grey-bg);
    cursor: not-allowed;
  }
  .comp-input.error textarea {
    border-color: var(--red);
  }

  .comp-input .error {
    position: absolute;
    top: calc(100% + 3px);
    left: 3px;
    width: 100%;
    font-size: 12px;
    font-weight: 600;
    color: var(--red);
  }

  .is-full-height {
    height: 100% !important;
  }

  .is-full-height > div.input-wrap {
    height: 100% !important;
  }

  .is-full-height textarea {
    height: 90% !important;
  }
</style>
